import {
  StyleSheet,
  View,
  Pressable,
  ViewStyle,
  TextStyle,
} from 'react-native';
import React from 'react';
import {spacing} from 'theme/Units';
import {Icon, Text} from 'ui-kits';
import colors from 'theme/Colors';
import { mergeDeepRight} from 'ramda';
import { v4 as uuid } from 'uuid';

type sizeTypes = 'lg' | 'md' | 'sm';

type propType = Readonly<{
  priority: number;
  mode?: 'edit' | 'read';
  label?: string;
  helperLabel?: string;
  optionalLabel?: string;
  required?: boolean;
  error?: string;
  size?: sizeTypes;
  onChange?: (priority: number) => void;
}>;
export function Priority(props: propType) {
  const {
    priority,
    mode = 'read',
    onChange,
    label,
    helperLabel,
    optionalLabel,
    required,
    size = 'md',
    error,
  } = props;

  const styles = mergeDeepRight(baseStyles, sizeStyles[size]) as styleType;

  return (
    <View style={styles.inputContainer}>
      {/* label and optional text */}
      {mode === 'edit' ? (
        <View style={styles.labelWrapper}>
          <Text style={styles.label}>
            {label}{' '}
            {required ? <Text style={styles.redAsterisk}>*</Text> : null}
          </Text>
          <Text style={styles.optionnalLabel}>{optionalLabel}</Text>
        </View>
      ) : null}

      {/* input wrapper  */}
      <View style={styles.inputWraper}>
        {mode === 'edit' ? <Icon type="priority" onPress={() => onChange}/> : null}
        {[...Array(5)].map((_, i) => (
          <Pressable key={uuid()} onPress={() => onChange?.(i + 1)}>
            <Icon type={i < priority ? 'star_yellow' : 'star_gray'} size={16} />
          </Pressable>
        ))}
      </View>

      {mode === 'edit' ? (
        <>
          {/* helper text and error label */}
          {helperLabel ? (
            <Text style={styles.helperLabel}>{helperLabel}</Text>
          ) : null}
          {error ? <Text style={styles.errorLabel}>{error}</Text> : null}
        </>
      ) : null}
    </View>
  );
}

type styleType = {
  inputContainer: ViewStyle;
  labelWrapper: ViewStyle;
  errorLabel: TextStyle;
  redAsterisk: TextStyle;
  editButton: ViewStyle;
  label: TextStyle;
  helperLabel: TextStyle;
  optionnalLabel: TextStyle;
  editButtonText: TextStyle;
  inputWraper: ViewStyle;
};

const baseStyles: styleType = StyleSheet.create({
  inputContainer: {
    gap: spacing['2'],
  },
  labelWrapper: {flexDirection: 'row', justifyContent: 'space-between'},
  errorLabel: {
    color: colors.palette.errorRedDark,
    fontSize: 12,
    fontWeight: '400',
  },
  redAsterisk: {color: colors.palette.errorRedDark},
  editButton: {
    width: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.palette.brandBlue,
    borderRadius: 999,
  },
  label: {
    color: colors.palette.black,
    fontWeight: '600',
    fontSize: 16,
  },
  helperLabel: {
    color: colors.palette.secondaryBlack5,
    fontSize: 12,
    fontWeight: '400',
  },
  optionnalLabel: {
    color: colors.palette.secondaryBlack5,
    fontSize: 12,
    fontWeight: '500',
  },
  editButtonText: {
    color: colors.palette.white,
  },
  inputWraper: {
    flexDirection: 'row',
    gap: spacing['1'],
    alignItems: 'center',
  },
});

const sizeStyles: Record<sizeTypes, Partial<styleType>> = {
  lg: {
    inputWraper: {
      height: 48,
      fontSize: 18,
    },
  },
  md: {
    inputWraper: {
      height: 40,
      fontSize: 14,
    },
  },
  sm: {
    inputWraper: {
      height: 32,
      fontSize: 14,
    },
  },
};
